export class ListSaasEntitiesRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SaasEntityTypeFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
